import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { BsFillPersonFill } from "react-icons/bs";
import { HiArrowUpTray, HiOutlinePhoto } from "react-icons/hi2";
import { useCookies } from "react-cookie";

import cf from "../UI/ClassicForm.module.css";
import { alertActions } from "../../store/alert-slice";
import { uploadPhoto } from "../../api/api";
import { authActions } from "../../store/auth-slice";
import Spinner from "../UI/Spinner";

const UploadPhoto = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const { jwt } = useCookies(["jwt"])[0];
  const photoRef = useRef();

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);
    const form = new FormData();
    const photo = photoRef.current.files[0];
    form.append("photo", photo);

    const res = await uploadPhoto(jwt, form);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({
          message: "Photo uploaded successfully",
          status: res.status,
        })
      );
      dispatch(authActions.refreshUser({ user: res.data.user }));
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };

  return (
    <form className={cf.form} onSubmit={submitHandler}>
      {showSpinner && <Spinner />}
      <div className={cf.formTitleRow}>
        <HiOutlinePhoto className={cf.formTitleIcon} aria-hidden />
        <h2 className={cf.formTitle}>Profile photo</h2>
      </div>
      <p className={cf.formSubtitle}>
        Upload a clear image. Supported formats depend on your browser; keep
        file size reasonable.
      </p>
      <div className={cf.field}>
        <label htmlFor="upload-photo">Choose file</label>
        <div className={cf.inputGroup}>
          <BsFillPersonFill className={cf.icon} />
          <input
            id="upload-photo"
            className={cf.fileInput}
            type="file"
            accept="image/*"
            ref={photoRef}
          />
        </div>
      </div>
      <div className={cf.actions}>
        <button type="submit">
          <HiArrowUpTray className={cf.btnIcon} aria-hidden />
          Update photo
        </button>
      </div>
    </form>
  );
};

export default UploadPhoto;
